<template>
  <div>
    <Head :title="form.name" />
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link href="/settings">Settings</Link></li>
        <li class="breadcrumb-item"><Link href="/settings/types">Types</Link></li>
        <li class="breadcrumb-item active" aria-current="page">{{ form.name }}</li>
      </ol>
    </nav>
    <h1>
      {{ form.name }}
    </h1>
    <trashed-message v-if="types.deleted_at" class="mb-6" @restore="restore"> This type has been deleted. </trashed-message>
    <div class="content-box">
      <form @submit.prevent="update">
        <TypeForm :form="form" />

        <div class="actions-toolbar d-flex justify-content-between">
          <button class="btn btn-outline-danger" tabindex="-1" type="button" @click="destroy">Delete Type</button>
          <loading-button :loading="form.processing" class="btn btn-primary" type="submit">Update Type</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TypeForm from './components/TypeForm'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    Head,
    Icon,
    Link,
    TypeForm,
    LoadingButton,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    types: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: this.types.name
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/settings/types/${this.types.id}`)
    },
    destroy() {
      if (confirm('Are you sure you want to delete this type?')) {
        this.$inertia.delete(`/settings/types/${this.types.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this type?')) {
        this.$inertia.put(`/settings/types/${this.types.id}/restore`)
      }
    },
  },
}
</script>
